import PropTypes from 'prop-types';
import React from 'react';
import Validator from 'mixins/validator';
import Resetter from 'mixins/resetter';
import { Button } from 'react-toolbox';
import { connect } from 'react-redux';
import SimpleInput from 'components/SimpleInput';
import RadioButtons from 'components/RadioButtons';
import S from 'modal.scss';
import PhaseType from 'types/phase';
import { getPhaseErrors } from '../../../../../../../../../reducers';

class InitialInfo extends Resetter(Validator(React.Component)) {
  state = {
    customerInitials: this.props.customerInitials || '',
    installerInitials: this.props.installerInitials || '',
    customerName: this.props.customerInitials || '',
    installerName: this.props.installerInitials || '',
    surfaceType: this.props.surfaceType || '',
    step: this.props.step || '',
    errors: {},
  };

  static VALIDATIONS = {
    customerInitials: true,
    customerName: true,
    installerInitials: true,
    installerName: true,
    step: true,
  }

  handleSubmit = () => {
    const { step, customerInitials, customerName,
      installerInitials, installerName } = this.state;
    if (!this.validate()) return;
    const tab = step === 'post' && this.props.surfaceType !== 'carpet' ? 3 : 2;
    this.props.updateFormData({
      customerInitials,
      customerName,
      installerInitials,
      installerName,
      step,
      tab,
    });
  }

  handleInstallerInitials = e => this.setState({ installerInitials: e.target.value });

  handleInstallerName = e => this.setState({ installerName: e.target.value });

  handleCustomerInitials = e => this.setState({ customerInitials: e.target.value });

  handleCustomerName = e => this.setState({ customerName: e.target.value });

  handleStep = value => this.setState({ step: value });

  render = () => {
    const { isSpanish } = this.props;
    const { customerInitials, customerName, installerInitials,
      installerName, errors, step } = this.state;

    const stepButtons = [
      { label: `${isSpanish ? 'Ante' : 'Pre'}`, value: 'pre' },
      { label: `${isSpanish ? 'Después' : 'Post'}`, value: 'post' },
    ];

    return (
      <div>
        <h6>{isSpanish ? 'Información Inicial' : 'Initial Info'}</h6>
        <RadioButtons
          label={isSpanish ? 'Seleccionar Tipo de Formulario*' : 'Select Form Type*'}
          required
          onChange={this.handleStep}
          selectedValue={step}
          radioButtons={stepButtons}
          text={isSpanish
            ? '¿Es esto antes o después de la instalación?'
            : 'Is this a pre- or post- walkthrough?'
          }
        />
        <SimpleInput
          label={isSpanish
            ? 'Escriba el nombre del instalador*'
            : 'Print Installer\'s Name*'
          }
          required
          text={installerName}
          errors={errors.installerName}
          onChange={this.handleInstallerName}
        />
        <SimpleInput
          label={isSpanish ? 'Iniciales de instalador*' : 'Installer Initials*'}
          required
          text={installerInitials}
          errors={errors.installerInitials}
          onChange={this.handleInstallerInitials}
        />
        <SimpleInput
          label={isSpanish
            ? 'Escriba el nombre del cliente*'
            : 'Print Customer\'s Name*'
          }
          required
          text={customerName}
          errors={errors.customerName}
          onChange={this.handleCustomerName}
        />
        <SimpleInput
          label={isSpanish ? 'Iniciales del cliente*' : 'Customer Initials*'}
          required
          text={customerInitials}
          errors={errors.customerInitials}
          onChange={this.handleCustomerInitials}
        />
        <Button
          label={isSpanish ? 'Próximo' : 'Next'}
          flat inverse ripple
          className={S.submit}
          onClick={this.handleSubmit}
        />
        <Button
          label={isSpanish ? 'Anterior' : 'Previous'}
          flat inverse ripple
          className={S.submit}
          onClick={this.handlePrevious}
        />
      </div>
    );
  }
}

InitialInfo.propTypes = {
  isSpanish: PropTypes.bool,
  phase: PhaseType.isRequired,
  customerInitials: PropTypes.string,
  installerInitials: PropTypes.string,
  customerName: PropTypes.string,
  installerName: PropTypes.string,
  surfaceType: PropTypes.string,
  step: PropTypes.string,
  errors: PropTypes.shape({
    installerInitials: PropTypes.arrayOf(PropTypes.string),
    customerInitials: PropTypes.arrayOf(PropTypes.string),
    installerName: PropTypes.arrayOf(PropTypes.string),
    customerName: PropTypes.arrayOf(PropTypes.string),
    surfaceType: PropTypes.arrayOf(PropTypes.string),
    step: PropTypes.arrayOf(PropTypes.string),
  }),
};

export default connect(state => ({ errors: getPhaseErrors(state) }), {})(InitialInfo);



// WEBPACK FOOTER //
// ./client/app/screens/main/screens/phases/phaseShow/components/tasks/components/WalkthroughModal/initialInfo.jsx